import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ExpandMoreTwoToneIcon from "@mui/icons-material/ExpandMoreTwoTone";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  Card,
  CardContent,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Typography,
  styled,
} from "@mui/material";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import "./App.css";
import { TESTIMONIAL } from "./assets/data/data";
import TopHeader from "./component/TopHeader";
import SettingsEthernetIcon from "@mui/icons-material/SettingsEthernet";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import React, { useRef, useState } from "react";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Service } from "./service/Service";
import "./../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { Autoplay, Navigation } from "swiper/modules";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import "swiper/css/navigation";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [open, setOpen] = React.useState(false);
  const [yearPicker, setYearPicker] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    year: "",
    number: "",
  });

  const DisabledAccordion = styled(Accordion)(({ theme }) => ({
    pointerEvents: "none", // Disable pointer events
    width: "60%",
    background: "rgb(33 102 171)",
    fontFamily: "sans-serif",
    fontSize: "larger",
    margin: "5px",
    borderLeft: "1px solid #553ac0",
    borderTop: "1px solid #553ac0",
    color: "white",
    "@media (max-width: 568px)": {
      width: "100%",
    },
  }));

  const AccordionCss = styled(Accordion)(({ theme }) => ({
    width: "60%",
    color: "white",
    background: "rgb(33 102 171)",
    fontFamily: "sans-serif",
    fontSize: "larger",
    margin: "5px",
    borderLeft: "1px solid #553ac0",
    borderTop: "1px solid #553ac0",
    "@media (max-width: 568px)": {
      width: "100%",
    },
  }));

  const buttonRefE = useRef(true);
  const handleButtonClick = (() => {
    let clicked = false;

    return () => {
      if (!clicked) {
        const imageElement = document.querySelector(
          "#gbot-main-container .bot-img"
        );
        if (imageElement) {
          imageElement.click();
          clicked = true;

          const handleClick = (event) => {
            if (event.target === imageElement) {
              clicked = false;
              document.removeEventListener("click", handleClick);
            }
          };

          document.addEventListener("click", handleClick);
        }
      }
    };
  })();

  const buttonRef = useRef(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSpanClick = () => {
    if (buttonRef.current) {
      buttonRef.current.click();
    }
  };

  const [errors, setErrors] = useState({});
  const validate = () => {
    let tempErrors = {};
    tempErrors.name = formData.name ? "" : "Name is required.";
    tempErrors.email = formData.email
      ? /\S+@\S+\.\S+/.test(formData.email)
        ? ""
        : "Email is not valid."
      : "Email is required.";
    tempErrors.year = formData.year ? "" : "Graduation Year is required.";
    tempErrors.number = formData.number
      ? formData.number.length === 10
        ? ""
        : "Mobile Number must be 10 digits."
      : "Mobile Number is required.";

    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };

  const handleChangeYearPicker = (event) => {
    setYearPicker(event.target.value);
    setFormData({ ...formData, year: event.target.value });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (validate()) {
      try {
        const response = await Service.TrainingEnquiry(formData);

        if (response === 200) {
          toast.info("Our team will contact you soon!");
        }

        setFormData({
          name: "",
          email: "",
          year: "",
          number: "",
        });
      } catch (error) {
        console.error("Error during training enquiry:", error);
        toast.error("An error occurred. Please try again later.");
      }
    }
  };

  const currentYear = new Date().getFullYear();
  const tenYearBack = currentYear - 8;
  const years = [];
  for (let year = currentYear; year >= tenYearBack; year--) {
    years.push(year);
  }

  return (
    <>
      <div className="banner">
        <TopHeader />
        <div className="inner-banner">
          <Grid
            container
            spacing={2}
            sx={{ justifyContent: " center", alignItems: "center" }}
          >
            <Grid item md={7} className="inner-grid-css">
              <div className="banner-content">
                <div className="ribbon">Pay fee after Placement</div>
                {/* <p></p> */}
                <p className="p-1">Fill Your Career Gap with Real Time</p>
                <p>
                  <CheckCircleOutlineRoundedIcon className="course-inclution-icon" />{" "}
                  Knowladge and Real Time Project Experience{" "}
                </p>
                <p>
                  <CheckCircleOutlineRoundedIcon className="course-inclution-icon" />{" "}
                  Intensive interview preparation from Day 1{" "}
                </p>
                <p>
                  <CheckCircleOutlineRoundedIcon className="course-inclution-icon" />{" "}
                  Highly efficient & interactive classroom{" "}
                </p>
                <p>
                  <CheckCircleOutlineRoundedIcon className="course-inclution-icon" />{" "}
                  Industry standard Syllabus by experts{" "}
                </p>
                <p>
                  <CheckCircleOutlineRoundedIcon className="course-inclution-icon" />{" "}
                  1-1 live doubt support{" "}
                </p>
                <div className="btn-div">
                  <React.Fragment>
                    <Button
                      ref={buttonRef}
                      variant="outlined"
                      className="download-btn"
                      startIcon={
                        <CloudDownloadIcon style={{ color: "while" }} />
                      }
                      onClick={handleClickOpen}
                    >
                      Download Syllabus
                    </Button>
                    <Dialog
                      open={open}
                      onClose={handleClose}
                      PaperProps={{
                        component: "form",
                        onSubmit: (event) => {
                          event.preventDefault();
                          const formData = new FormData(event.currentTarget);
                          const formJson = {};
                          for (const [key, value] of formData.entries()) {
                            formJson[key] = value;
                          }
                          const name = formJson.name;
                          const email = formJson.email;
                          console.log(`Name: ${name}, Email: ${email}`);
                          Service.SendSyllabus(formJson);
                          toast.info("Check your email");
                          handleClose();
                        },
                      }}
                    >
                      <DialogTitle>Syllabus</DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          Please Enter Your Name & Email Id.
                        </DialogContentText>
                        <TextField
                          id="name"
                          name="name"
                          label="Name"
                          variant="standard"
                          margin="dense"
                          autoFocus
                          required
                          fullWidth
                        />
                        <TextField
                          autoFocus
                          required
                          margin="dense"
                          id="email"
                          name="email"
                          label="Email Address"
                          type="email"
                          fullWidth
                          variant="standard"
                        />
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit">Get </Button>
                      </DialogActions>
                    </Dialog>
                  </React.Fragment>

                  <Button
                    ref={buttonRefE}
                    variant="outlined"
                    className="download-btn"
                    startIcon={<EmojiEmotionsIcon style={{ color: "while" }} />}
                    onClick={handleButtonClick}
                  >
                    Enroll Now
                  </Button>
                </div>
                {/* <img
                        src={require("./assets/images/Programming-1.png")}
                        alt="" className="inner-grid-css-img"
                      />    */}
              </div>
            </Grid>
            <Grid
              item
              md={5}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Card sx={{ zIndex: "2" }}>
                <div className="inquiry-card">
                  <FormControl
                    fullWidth
                    component="form"
                    onSubmit={handleSubmit}
                  >
                    <div>
                      <div className="div-label-head">
                        Speak to Our Team and clear your doubts!
                        <br />
                        Fill out the form below!
                      </div>
                      <div>
                        <TextField
                          id="name"
                          name="name"
                          label="Name"
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          value={formData.name}
                          onChange={handleChange}
                          error={!!errors.name}
                          helperText={errors.name}
                        />
                        <TextField
                          id="email"
                          name="email"
                          label="Email Address"
                          type="email"
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          value={formData.email}
                          onChange={handleChange}
                          error={!!errors.email}
                          helperText={errors.email}
                        />
                        <div className="div-select">
                          <FormControl
                            label="Graduation Year"
                            labelId="demo-simple-select-label"
                            required
                          >
                            <InputLabel id="gradutationYear">
                              Graduation Year
                            </InputLabel>
                            <Select
                              labelId="gradutationYear"
                              id="gradutationYear"
                              value={formData.year}
                              label="Graduation Year"
                              onChange={handleChangeYearPicker}
                              fullWidth
                              error={!!errors.year}
                            >
                              {years.map((year) => (
                                <MenuItem key={year} value={year}>
                                  {year}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.year && (
                              <p
                                style={{
                                  color: "red",
                                  marginTop: "4px",
                                  marginLeft: "14px",
                                }}
                              >
                                {errors.year}
                              </p>
                            )}
                          </FormControl>
                        </div>
                        <div className="div-form-label">
                          <label className="form-label">+91</label>
                          <TextField
                            id="number"
                            name="number"
                            label="Mobile Number"
                            variant="outlined"
                            margin="dense"
                            required
                            fullWidth
                            value={formData.number}
                            onChange={handleChange}
                            error={!!errors.number}
                            helperText={errors.number}
                          />
                        </div>
                        <Button
                          variant="contained"
                          className="btn-css"
                          type="submit"
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </FormControl>
                </div>
              </Card>
            </Grid>
          </Grid>
        </div>
        <img
          className="wave-img"
          src={require("./assets/images/wave.png")}
          alt=""
          style={{ width: "100%" }}
        />
      </div>

      <div id="about-us-button" style={{ marginTop: "4%" }}>
        <h2 style={{ textAlign: "center" }} className="css-heading">
          Our Success Story
        </h2>
        <Divider />
        <Grid item xs={12}>
          <Swiper
            spaceBetween={7}
            slidesPerView={3}
            modules={[Autoplay]}
            loop={true}
            autoplay={{
              delay: 1000,
              disableOnInteraction: false,
            }}
            // onSlideChange={() => console.log("slide change")}
            // onSwiper={(swiper) => console.log(swiper)}
            breakpoints={{
              320: {
                slidesPerView: 1,
              },
              480: {
                slidesPerView: 1,
              },
              640: {
                slidesPerView: 2,
              },
              800: {
                slidesPerView: 2,
              },
              1000: {
                slidesPerView: 2,
              },
              1340: {
                slidesPerView: 3,
              },
            }}
          >
            {TESTIMONIAL.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="testimonial-item">
                  <div
                    className="testimonial-item-sub"
                    style={{ background: "#2166ab", color: "white" }}
                  >
                    <div className="scoller">
                      <img src={require(`${item.image}`)} alt={item.name} />
                      <div>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <a href={item.linkdin} target="_blank">
                            <img
                              src={require("./assets/images/linkdin.png")}
                              alt="LinkedIn"
                              style={{
                                width: "19px",
                                height: "19px",
                                padding: "1px",
                                border: "none",
                              }}
                            />
                          </a>
                          {item.name}
                        </span>
                        <span>{item.company}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Grid>

        <div className="mobile-mb">
          <Grid
            container
            spacing={2}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Grid item md={6}>
              <div style={{ marginTop: "8px" }}>
                <img
                  className="class-img"
                  src={require("./assets/images/class.jpg")}
                  alt=""
                  style={{ width: "100%" }}
                />
              </div>
            </Grid>
            <Grid item md={6}>
              <div className="about-us">
                <li>
                  Cutting-Edge Curriculum: Gateway2IT offers courses designed to
                  equip learners with the latest tools, techniques, and
                  knowledge essential for success in the ever-evolving IT
                  landscape.
                </li>
                <li>
                  Expert Instructors: Our instructors are industry experts
                  passionate about sharing their knowledge and guiding students
                  towards success, ensuring a supportive and enriching learning
                  experience.
                </li>
                <li>
                  Flexible Learning Options: Whether it's online courses,
                  instructor-led training, or customized corporate solutions,
                  Gateway2IT provides flexible learning options tailored to
                  individual preferences and business needs.
                </li>
                <li>
                  Hands-On Experience: Through practical sessions, real-world
                  projects, and interactive discussions, learners gain not only
                  theoretical understanding but also the confidence to apply
                  their skills in real-life scenarios.
                </li>
                <li>
                  Lifelong Support: Gateway2IT's commitment to excellence
                  extends beyond the duration of the courses, offering ongoing
                  support and a vibrant community of learners and professionals
                  for networking, collaboration, and continuous learning.
                </li>{" "}
              </div>
            </Grid>
          </Grid>
        </div>

        <div className="section-3-banner">
          <Grid container spacing={2}>
            <Grid item md={1}></Grid>
            <Grid item md={10}>
              <Grid container spacing={2}>
                <Grid item md={4}>
                  <Paper elevation={2} className="section-3-card">
                    <img
                      className="class-img"
                      src={require("./assets/images/support.jpg")}
                      alt=""
                      style={{ width: "100%" }}
                    />
                    <h3>Placement Support</h3>
                    <p>
                      Complete support from our dedicated placement team until
                      you get a job
                    </p>
                  </Paper>
                </Grid>
                <Grid item md={4}>
                  <Paper elevation={3} className="section-3-card">
                    <img
                      className="class-img"
                      src={require("./assets/images/resume.jpg")}
                      alt=""
                      style={{ width: "100%" }}
                    />
                    <h3>Resume Building</h3>
                    <p>Resume sharing in our network of hiring partners</p>
                    <br />
                  </Paper>
                </Grid>
                <Grid item md={4}>
                  <Paper elevation={3} className="section-3-card">
                    <img
                      className="class-img"
                      src={require("./assets/images/interview.jpg")}
                      alt=""
                      style={{ width: "100%" }}
                    />
                    <h3>Mock Interviews</h3>
                    <p>Professional mock interviews assistance</p>
                    <br />
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>

      <div className="tools-section-sub">
        <div className="tools-section">
          <h2 className="css-heading">SKILL YOU WILL LEARN IN THE COURSE</h2>
          <h5 className="css-heading">
            Embark on your journey to becoming a Java Full Stack Developer: From
            Back-end Mastery to Front-end Excellence.
          </h5>
          <div style={{ marginTop: "10%", cursor: "pointer" }}>
            <a onClick={handleButtonClick}>Enroll Now</a>
          </div>
        </div>
        <div className="tools-items">
          <div className="tools-box">
            <div className="item">
              <img src={require("./assets/images/tools/Frame1.png")} alt="" />
            </div>
            <div className="item">
              <img src={require("./assets/images/tools/Frame6.png")} alt="" />
            </div>
            <div className="item">
              <img src={require("./assets/images/tools/Frame8.png")} alt="" />
            </div>
            <div className="item">
              <img src={require("./assets/images/tools/Frame11.png")} alt="" />
            </div>
          </div>
          <div className="tools-box">
            <div className="item">
              <img src={require("./assets/images/tools/Frame13.png")} alt="" />
            </div>
            <div className="item">
              <img src={require("./assets/images/tools/Frame14.png")} alt="" />
            </div>
            <div className="item">
              <img src={require("./assets/images/tools/Frame15.png")} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="learn">
        <div className="learn-main-header">
          <h1>
            <i className="icon icon-success" style={{ top: "1px " }}></i>{" "}
            {/* Learn the Gateway2IT Way */}
            Learn, Innovate & Succeed
          </h1>
          <h3>
            Build your skills step-by-step with our momentum-driven approach.
          </h3>
        </div>
        <div className="learn-main ">
          <Card className="card-css">
            <CardContent>
              <Typography variant="body2">
                <h3>
                  <SettingsEthernetIcon className="plan-inclution-span" />
                  Code Everyday
                </h3>
                <Divider sx={{ background: "#553ac0" }} />
                <h5>
                  {" "}
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Practitioner-led Live Classes
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Booster Practice Sessions
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Full Day Doubt Support
                </h5>
              </Typography>
            </CardContent>
          </Card>

          <Card className="card-css">
            <CardContent>
              <Typography variant="body2">
                <h3>
                  <CheckBoxOutlinedIcon className="plan-inclution-span" />
                  Personalized Progress Evaluation
                </h3>
                <Divider sx={{ background: "#553ac0" }} />
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />
                  Weekly Test
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  1:1 Mentorship
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Soft Skill Sessions
                </h5>
              </Typography>
            </CardContent>
          </Card>
          <Card className="card-css">
            <CardContent>
              <Typography variant="body2">
                <h3>
                  <QuestionAnswerOutlinedIcon className="plan-inclution-span" />
                  Interview Preparation Every Month
                </h3>
                <Divider sx={{ background: "#553ac0" }} />
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Mock Interviews
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />
                  Industry standard Syllabus
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />
                  Real World Projects
                </h5>
              </Typography>
            </CardContent>
          </Card>
          <Card className="card-css">
            <CardContent>
              <Typography variant="body2">
                <h3>
                  <TrackChangesOutlinedIcon className="plan-inclution-span" />
                  Intensive Placement Assistance
                </h3>
                <Divider sx={{ background: "#553ac0" }} />
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />
                  Profile Building
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Interview Preparation
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Job Referrals
                </h5>
              </Typography>
            </CardContent>
          </Card>
        </div>
      </div>

      <Grid container spacing={2} className="testimonial-section">
        <Grid item xs={12} style={{ marginBottom: "-40px" }}>
          <h2
            style={{ textAlign: "center", marginTop: "2vh", fontFamily: "Roboto" }}
            className="css-heading"
          >
            Testimonials
          </h2>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <Swiper
            spaceBetween={5}
            slidesPerView={1}
            modules={[Navigation]}
            // onSlideChange={() => console.log("slide change")}
            // onSwiper={(swiper) => console.log(swiper)}
            navigation={true}
          >
            {TESTIMONIAL.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="testimonial-item">
                  <div className="testimonial-item-sub">
                    <div className="image">
                      <div className="inner-image">
                        <img src={require(`${item.image}`)} alt={item.name} />
                      </div>
                    </div>
                    <div className="info">
                      <h2 className="css-heading">
                        <a
                          href={item.linkdin}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={require("./assets/images/linkdin.png")}
                            alt="LinkedIn"
                            height={"28px"}
                          />
                        </a>
                        {item.name}
                      </h2>
                      <h3 className="css-heading">{item.company}</h3>
                      <h3 className="css-heading">{item.college}</h3>
                    </div>
                  </div>
                  <div className="quote">
                    <p>{item.quote}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Grid>
      </Grid>

      <div className="learn" id="course-button">
        <div className="learn-main-header">
          <h1>
            <i className="icon icon-success" style={{ top: "1px " }}></i>{" "}
            Course's
          </h1>
          <h1>
            <i className="icon icon-success" style={{ top: "1px " }}></i>{" "}
            Eligibility : Fresher | Experience
          </h1>
        </div>
        <div className="course-main ">
          <Card className="card-css">
            <CardContent>
              <Typography variant="body2">
                <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    marginBottom: "11px",
                    color: "#098309",
                  }}
                >
                  <img
                    src={require("./assets/images/tools/fs.png")}
                    alt=""
                    style={{
                      // width: "8vh",
                      height: "8vh",
                    }}
                  />
                  <span>Full stack java developer</span>
                </Typography>
                <Divider sx={{ background: "#553ac0" }} />

                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  <strong> Pay after placement, duration 12 months</strong>
                </h5>
                <h5 onClick={handleSpanClick} style={{ cursor: "pointer" }}>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Download Syllabus
                </h5>
                <p className="course-inclution">Eligibility</p>
                {[
                  "MCA/BCA",
                  "M.Sc(IT/CS)/B.Sc(IT/CS)",
                  "B.tech/M.tech any branch",
                  "Passed out Student Only",
                  "knowledge of basic programming",
                  "Basic Problem-solving skills",
                ].map((text, index) => (
                  <h5 key={index}>
                    <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />
                    {text}
                  </h5>
                ))}

                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Live Project Work
                </h5>
              </Typography>
            </CardContent>
          </Card>

          <Card className="card-css">
            <CardContent>
              <Typography variant="body2">
                <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    marginBottom: "11px",
                    color: "#098309",
                  }}
                >
                  <img
                    src={require("./assets/images/tools/fs.png")}
                    alt=""
                    style={{
                      // width: "8vh",
                      height: "8vh",
                    }}
                  />
                  <span>Full stack java developer</span>
                </Typography>
                <Divider sx={{ background: "#553ac0" }} />
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  <strong> Pay after placement, duration 8 months</strong>
                </h5>
                <h5 onClick={handleSpanClick} style={{ cursor: "pointer" }}>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Download Syllabus
                </h5>
                <p className="course-inclution">Eligibility</p>
                {[
                  "MCA/BCA",
                  "M.Sc(IT/CS)/B.Sc(IT/CS)",
                  "B.tech/M.tech any branch",
                  "Passed out Student Only",
                  "knowledge of basic programming",
                  "Problem-solving skills/knowledge of any database",
                ].map((text, index) => (
                  <h5 key={index}>
                    <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />
                    {text}
                  </h5>
                ))}

                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Live Project Work
                </h5>
              </Typography>
            </CardContent>
          </Card>

          <Card className="card-css">
            <CardContent>
              <Typography variant="body2" component="div">
                <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#ea2d2e",
                    flexDirection: "column",
                    marginBottom: "11px",
                  }}
                >
                  <img
                    src={require("./assets/images/tools/java.png")}
                    alt=""
                    style={{
                      width: "10vh",
                      height: "8vh",
                    }}
                  />
                  <span>Java Core</span>
                </Typography>

                <Divider sx={{ background: "#553ac0" }} />
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  <strong> Fee ₹10,000 duration 2.5 months</strong>
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Introduction to Java, Control Flow
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Object-Oriented Programming (OOP), Generics
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Exception Handling, Collections Framework
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  File Handling, Packages and Access Modifiers
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Introduction to JDBC, Debugging and Testing
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  String Handling, Wrapper Classes and Autoboxing
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Wrapper Classes and Autoboxing
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Live Project Work
                </h5>
              </Typography>
            </CardContent>
          </Card>
          <Card className="card-css">
            <CardContent>
              <Typography variant="body2">
                <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#69b72a",
                    flexDirection: "column",
                    marginBottom: "11px",
                  }}
                >
                  <img
                    src={require("./assets/images/tools/spring.png")}
                    alt=""
                    style={{
                      width: "10vh",
                      height: "8vh",
                    }}
                  />
                  <span>Spring & Microservices</span>
                </Typography>
                <Divider sx={{ background: "#553ac0" }} />
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  <strong> Fee ₹30,000 duration 4 months</strong>
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Introduction to Spring Boot, Building RESTful APIs with Spring
                  Boot
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Spring Boot Data Access, Spring Cloud, Microservices
                  Architecture
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Containerization with Docker, Orchestration with Kubernetes,
                  Monitoring and Logging
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Security in Microservices, Monitoring and Logging, Testing
                </h5>

                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Microservices, JPA & Hibernate
                </h5>

                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Live Project Work
                </h5>
              </Typography>
            </CardContent>
          </Card>
          <Card className="card-css">
            <CardContent>
              <Typography variant="body2">
                <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    marginBottom: "11px",
                  }}
                >
                  <img
                    src={require("./assets/images/tools/angular.png")}
                    alt=""
                    style={{
                      width: "8vh",
                      height: "8vh",
                    }}
                  />
                  <span>Angular</span>
                </Typography>
                <Divider sx={{ background: "#553ac0" }} />
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  <strong> Fee ₹15,000 duration 3 months</strong>
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Introduction to Angular, Setting Up Development Environment,
                  Angular Components
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Templates and Data Binding, RxJS and Observables, Directives
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Services and Dependency Injection, Routing and Navigation
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Forms and Validations, HTTP Client, Angular Modules
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Angular Material, Authentication and Authorization
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Deployment and Optimization, Crud operation
                </h5>

                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Live Project Work
                </h5>
              </Typography>
            </CardContent>
          </Card>
          <Card className="card-css">
            <CardContent>
              <Typography variant="body2">
                <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#00ccff",
                    flexDirection: "column",
                    marginBottom: "11px",
                  }}
                >
                  <img
                    src={require("./assets/images/tools/react.png")}
                    alt=""
                    style={{
                      width: "10vh",
                      height: "8vh",
                    }}
                  />
                  <span>React Js</span>
                </Typography>
                <Divider sx={{ background: "#553ac0" }} />
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  <strong> Fee ₹15,000 duration 3 months</strong>
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Introduction to React, Setting Up Development Environment
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  JSX(JavaScript XML), Components, Props and State
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Handling Events, Lists and Keys, Forms
                </h5>
                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Conditional Rendering, Styling, React Router
                </h5>

                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Managing State with Context API, Hooks, Fetching Data, Forms
                </h5>

                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Error Handling, Testing, Deployment, Crud operation
                </h5>

                <h5>
                  <CheckCircleOutlineRoundedIcon className="plan-inclution-span" />{" "}
                  Live Project Work
                </h5>
              </Typography>
            </CardContent>
          </Card>
        </div>
      </div>

      <div className="curriculum-css" id="syllabus-button">
        <h1>
          Curriculum
          <br />
          <span>
            The curriculum, learning content and projects are designed and
            created by <strong>Gateway2IT</strong> faculty in coordination with
            leading Industry experts . The specializations help you build extra
            skill and making you a future ready Technology professional.
          </span>
        </h1>

        <h2>
          <i className="icon icon-success" style={{ top: "2px" }}></i> Pre-work
        </h2>
        <AccordionCss>
          <AccordionSummary
            expandIcon={
              <ExpandMoreTwoToneIcon
                className="plan-inclution-span"
                sx={{ fontSize: "xx-large", color: "white" }}
              />
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            Introduction to Programming - Java
          </AccordionSummary>
          <AccordionDetails>
            <li>Program structure & basic principles</li>
            <li>Programming constructs - loops, functions, arrays, etc.</li>
          </AccordionDetails>
        </AccordionCss>

        <DisabledAccordion>
          <AccordionSummary>
            An introduction to version control, Git
          </AccordionSummary>
        </DisabledAccordion>

        <DisabledAccordion>
          <AccordionSummary>Basic HTML,CSS</AccordionSummary>
        </DisabledAccordion>

        <h2>
          <i className="icon icon-success" style={{ top: "2px" }}></i> Back end
          Software Development
        </h2>
        <AccordionCss>
          <AccordionSummary
            expandIcon={
              <ExpandMoreTwoToneIcon
                className="plan-inclution-span"
                sx={{ fontSize: "xx-large", color: "white" }}
              />
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            Object-oriented Programming - Java
          </AccordionSummary>
          <AccordionDetails>
            <li>
              Object Oriented paradigms of Java Programming (Classes, Objects
              etc.)
            </li>
            <li>Exception Handling, Collections etc.</li>
          </AccordionDetails>
        </AccordionCss>

        <AccordionCss>
          <AccordionSummary
            expandIcon={
              <ExpandMoreTwoToneIcon
                className="plan-inclution-span"
                sx={{ fontSize: "xx-large", color: "white" }}
              />
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            Data Structures - Java
          </AccordionSummary>
          <AccordionDetails>
            <li>
              Linear Data Structures (Arrays, Strings, Stacks, Queues, Linked
              Lists, etc.)
            </li>
            <li>Binary Trees and Binary Search Trees, Tree traversals</li>
          </AccordionDetails>
        </AccordionCss>

        <AccordionCss>
          <AccordionSummary
            expandIcon={
              <ExpandMoreTwoToneIcon
                className="plan-inclution-span"
                sx={{ fontSize: "xx-large", color: "white" }}
              />
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            Algorithms - Java
          </AccordionSummary>
          <AccordionDetails>
            <li>
              Basic Algorithms: Recursion, Searching and Sorting Algorithms
            </li>
            <li>
              Analysis of an Algorithms and Evaluating the right algorithm for a
              problem
            </li>
            <li>
              Self study – Greedy Algorithms, Advanced algorithms – Graphs,
              Dynamic Programming, Hashing Algorithms
            </li>
          </AccordionDetails>
        </AccordionCss>

        <AccordionCss>
          <AccordionSummary
            expandIcon={
              <ExpandMoreTwoToneIcon
                className="plan-inclution-span"
                sx={{ fontSize: "xx-large", color: "white" }}
              />
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            Database Design & Systems
          </AccordionSummary>
          <AccordionDetails>
            <li>Processing, storing & organizing data: data models, ETL</li>
            <li>Tables, views, SQL queries - simple & complex</li>
            <li>Database schemas, normalization, keys, indexes</li>
            <li>JDBC</li>
            <li>Self study – Introduction to NoSQL databases</li>
          </AccordionDetails>
        </AccordionCss>

        <AccordionCss>
          <AccordionSummary
            expandIcon={
              <ExpandMoreTwoToneIcon
                className="plan-inclution-span"
                sx={{ fontSize: "xx-large", color: "white" }}
              />
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            Server-side development & Frameworks
          </AccordionSummary>
          <AccordionDetails>
            <li>Spring MVC Architecture</li>
            <li>Backend development using Springboot framework</li>
            <li>ORM & Hibernate</li>
            <li>REST APIs</li>
          </AccordionDetails>
        </AccordionCss>

        <h2>
          <i className="icon icon-success" style={{ top: "2px" }}></i> Front end
          Software Development
        </h2>
        <AccordionCss>
          <AccordionSummary
            expandIcon={
              <ExpandMoreTwoToneIcon
                className="plan-inclution-span"
                sx={{ fontSize: "xx-large", color: "white" }}
              />
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            HTML & CSS
          </AccordionSummary>
          <AccordionDetails>
            <li>HTML & CSS interaction</li>
            <li>
              CSS: styling, selectors, box model, border, margin, padding, etc
            </li>
          </AccordionDetails>
        </AccordionCss>

        <AccordionCss>
          <AccordionSummary
            expandIcon={
              <ExpandMoreTwoToneIcon
                className="plan-inclution-span"
                sx={{ fontSize: "xx-large", color: "white" }}
              />
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            JavaScript
          </AccordionSummary>
          <AccordionDetails>
            <li>
              JavaScript Fundamentals, Hoisting, Callbacks, Promises,
              Asynchronous JavaScript, DOM Manipulation, JSON, AJAX Calls,
              Communication with Server, Event Listeners, Local and Session
              Storage etc.
            </li>
            <li>
              Advanced JavaScript –ES6, Let & Const, Arrow Functions, Array
              Destructuring, Async/Await etc
            </li>
          </AccordionDetails>
        </AccordionCss>

        <AccordionCss>
          <AccordionSummary
            expandIcon={
              <ExpandMoreTwoToneIcon
                className="plan-inclution-span"
                sx={{ fontSize: "xx-large", color: "white" }}
              />
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            JavaScript Frameworks – React
          </AccordionSummary>
          <AccordionDetails>
            <li>
              React Introduction, React Router, components and Single Page
              applications
            </li>
          </AccordionDetails>
        </AccordionCss>
      </div>

      <footer className="footer-distributed" id="contact-us-button">
        <div className="footer-left">
          <img src={require("./assets/images/footer-icon.png")} alt="" />
          <p className="footer-links">
            <a href="#">Home</a>|
            <a href="https://www.instagram.com/gateway2it" target="_blank">
              Blog
            </a>
            |<a href="#about-us-button">About</a>|
            <a href="#contact-us-button">Contact</a>
          </p>

          <p className="footer-company-name">© 2024 Gateway2IT Pvt. Ltd.</p>
        </div>

        <div className="footer-center">
          <div>
            <FmdGoodOutlinedIcon
              sx={{ position: "relative", marginRight: "5px", top: "-1vh" }}
            />
            <p>
              <span> Shivaji Nagar Colony, Samne Ghat</span>
              varanasi, UP-221005
            </p>
          </div>

          <div>
            <LocalPhoneOutlinedIcon
              sx={{ position: "relative", marginRight: "5px" }}
            />
            <p>
              +91-9310436193 <br />
              +91-8187971498
            </p>
          </div>
          <div>
            <MailOutlinedIcon
              sx={{ top: "7px", position: "static", marginRight: "5px" }}
            />
            <p>
              <a href="mailto:contact@gateway2it.com">contact@gateway2it.com</a>
            </p>
          </div>
        </div>
        <div className="footer-right">
          <p className="footer-company-about">
            <span>About the company</span>
            Gateway2it offers indispensable IT skills and in-depth training, preparing individuals to thrive in the fast-paced technology sector.
          </p>
          <div class="footer-icons">
            <a href="https://www.youtube.com/@Gateway2IT" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="26"
                fill="currentColor"
                class="bi bi-youtube"
                viewBox="0 0 16 16"
              >
                <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
              </svg>
            </a>
            <a
              href="https://in.linkedin.com/company/mars-information-system"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-linkedin"
                viewBox="0 0 16 16"
              >
                <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
              </svg>
            </a>
            <a href="https://www.facebook.com/marsisystem" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-facebook"
                viewBox="0 0 16 16"
              >
                <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
              </svg>
            </a>
            <a href="https://www.instagram.com/gateway2it" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-instagram"
                viewBox="0 0 16 16"
              >
                <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
              </svg>
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}

export default App;
